import React from "react";
import {
  CardBody,
  CardWrapper,
  Column,
  Grid,
  Row,
  Content,
  CONTENT_TYPES,
} from "cdk-radial";
import styled from "styled-components";
import { injectIntl } from "react-intl";
// import logoCDK_Rev from "../../images/CDK_Logo_Horiz_Reg_RGB_Reverse.svg";
import logoCDK_Rev from "../../images/cdk_white_footer.svg";
import {
  CVR_BRAND_NAME,
  FORD_BRAND_NAME,
  getBrand,
  getDefaultBrand,
} from "./ProductBrand";
import LocaleToggle from "../../containers/LocaleToggle";
import { useCookies } from "react-cookie";
import { isEmpty } from "lodash";
import getFromCookie from "../../utils/cookieUtil";

const CommonLayout = (props) => {
  const cookies = useCookies();
  let originalTarget = getFromCookie(cookies, "originalTarget");
  let productBrand = !isEmpty(originalTarget) && getBrand(originalTarget);
  productBrand = productBrand ? productBrand : getDefaultBrand();

  let showCDKFooter = true;
  if (
    !isEmpty(productBrand) &&
    (productBrand.name === CVR_BRAND_NAME ||
      productBrand.name === FORD_BRAND_NAME)
  ) {
    showCDKFooter = false;
  }

  return (
    <MainScreen>
      {/* <AppBackground id="CommonLayoutBackground" /> */}
      <CommonLayoutContainer id="CommonLayoutContainer">
        <CommonHeaderDiv>
          <HeaderRightSmall>
            {productBrand && <CommonBrandSmallImage src={productBrand.img} />}
          </HeaderRightSmall>
          <LocaleChipContainer id="localeChipContainer">
            <LocaleToggle />
          </LocaleChipContainer>
        </CommonHeaderDiv>
        <CommonContentDiv id="CommonContentDiv">
          <StyledGrid id="StyledGrid">
            <Row>
              <StyledColumn l={12} m={12} s={12} xl={6} xs={12}>
                {productBrand && (
                  <CommonCardMediaImage
                    src={
                      productBrand.isConnectCdk ? logoCDK_Rev : productBrand.img
                    }
                  />
                )}
              </StyledColumn>
              <StyledColumn l={12} m={12} s={12} xl={6} xs={12}>
                <LoginCardWrapper draggable={false}>
                  <CardBodyStyled>
                    {React.Children.only(props.children)}
                    <StyledDiv>
                      {showCDKFooter ? (
                        <CommonFooterContent
                          tag="div"
                          type={CONTENT_TYPES.CAPTION}
                        >
                          ®{getCurrentYear()} CDK Global, LLC
                        </CommonFooterContent>
                      ) : null}
                    </StyledDiv>
                  </CardBodyStyled>
                </LoginCardWrapper>
              </StyledColumn>
            </Row>
          </StyledGrid>
        </CommonContentDiv>
      </CommonLayoutContainer>
    </MainScreen>
  );
};

const LoginCardWrapper = styled(CardWrapper)`
  margin-top: 0.5em;
  max-width: 432px;
  height: 600px;
  @media (max-width: 320px) {
    box-shadow: none;
    border-radius: none;
  }
`;

const StyledDiv = styled.div`
  text-align: center;
`;

const StyledColumn = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 100%;
`;

const StyledGrid = styled(Grid)`
  padding-bottom: 2em;
  padding-right: 2em;
  padding-left: 2em;
  padding-top: 1em;
  @media (max-width: 320px) {
    padding: 0em;
  }
`;

const CommonFooterContent = styled(Content)`
  font-weight: normal;
  margin-top: 2em;
  margin-bottom: 1em;
  bottom: 0px;
`;

const CommonCardMediaImage = styled.img`
  max-width: 400px;
  max-height: 114px;
  padding: 1em;
  @media (max-width: 320px) {
    display: none;
  }
`;

const CommonBrandSmallImage = styled.img`
  min-width: 187px;
  min-height: 20px;
  padding-right: 1em;
  padding-left: 1.5em;
  align-self: flex-end;
  margin-bottom: 0.5em;
  @media (min-width: 321px) {
    display: none;
  }
`;

const HeaderRightSmall = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  @media (min-width: 321px) {
    display: none;
  }
`;

const CommonLayoutContainer = styled.div`
  display: flex;
  flex: 100%;
  flex-wrap: wrap;
  @media (max-width: 320px) {
    background-color: #ffffff;
  }
`;

const CommonHeaderDiv = styled.div`
  flex: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  margin-top: 0 em;
  @media (max-width: 321px) {
    margin-top: 1.5em;
  }
`;

const LocaleChipContainer = styled.div`
  @media (max-width: 320px) {
    margin-right: 0.5em;
  }
`;

const CommonContentDiv = styled.div`
  display: flex;
  flex: 100%;
`;

const MainScreen = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

const CardBodyStyled = styled(CardBody)`
  justify-content: space-between;
`;

const getCurrentYear = () => {
  const d = new Date();
  return d.getFullYear();
};

export default injectIntl(CommonLayout);
